// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"22073f73","884":"a95d678b"}[chunkId] + ".chunk.js";
};